import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { viewerType } from 'ngx-doc-viewer';
import { DocumentViewerDialogData, FileExtension } from '../app-document-models';

@Component({
  selector: 'sca-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit {
  public documentURL: string = ''
  public viewer: viewerType = 'url';

  constructor(public dialogRef: MatDialogRef<DocumentViewerDialogData>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentViewerDialogData
  ) { }

  ngOnInit(): void {
    this.documentURL = this.data.fileURL;

    switch(this.data.fileExtension) {
      case FileExtension.PDF:
      case FileExtension.PNG:
      case FileExtension.JPG:
      case FileExtension.JPEG:
      case FileExtension.GIF:
      case FileExtension.BMP:
        this.viewer = 'pdf';
        break;
      // case FileExtension.DOC:
      // case FileExtension.DOCX:
      //   this.viewer = 'mammoth';
      //   break;
    }
  }

  public onCloseButtonClick(): void {
    this.dialogRef.close();
  }
}
